function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.21.588 on 2025-10-15 09:40:27.

;
export var IApiRestCurriculumsClient = /*#__PURE__*/function () {
  function IApiRestCurriculumsClient(httpClient) {
    _classCallCheck(this, IApiRestCurriculumsClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP POST /api/_cv/n
   * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoCV
   */
  return _createClass(IApiRestCurriculumsClient, [{
    key: "nuevoCV",
    value: function nuevoCV(alta, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject || (_templateObject = _taggedTemplateLiteral(["api/_cv/n"]))),
        data: alta,
        options: options
      });
    }

    /**
     * HTTP POST /api/_cv/n/{token}/f
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoFicheroParaCV
     */
  }, {
    key: "nuevoFicheroParaCV",
    value: function nuevoFicheroParaCV(token, queryParams, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["api/_cv/n/", "/f"])), token),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP POST /api/_cv/n2
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoCV_Secured
     */
  }, {
    key: "nuevoCV_Secured",
    value: function nuevoCV_Secured(alta, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["api/_cv/n2"]))),
        data: alta,
        options: options
      });
    }
  }]);
}();
export var IApiRestDatosClient = /*#__PURE__*/function () {
  function IApiRestDatosClient(httpClient) {
    _classCallCheck(this, IApiRestDatosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/priv/_dat/doc
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.tiposParaDocuemntos
   */
  return _createClass(IApiRestDatosClient, [{
    key: "tiposParaDocuemntos",
    value: function tiposParaDocuemntos(queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["api/priv/_dat/doc"]))),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_dat/st/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.nuevoEstadoDoc
     */
  }, {
    key: "nuevoEstadoDoc",
    value: function nuevoEstadoDoc(cambioEstado, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["api/priv/_dat/st/add"]))),
        data: cambioEstado,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_dat/st/gest
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.leerEstadosDoc
     */
  }, {
    key: "leerEstadosDoc",
    value: function leerEstadosDoc(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["api/priv/_dat/st/gest"]))),
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_dat/st/{idestado}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.cambioEstadoDoc
     */
  }, {
    key: "cambioEstadoDoc",
    value: function cambioEstadoDoc(idestado, cambioEstado, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["api/priv/_dat/st/", ""])), idestado),
        data: cambioEstado,
        options: options
      });
    }
  }]);
}();
export var IApiRestDocumentacionClient = /*#__PURE__*/function () {
  function IApiRestDocumentacionClient(httpClient) {
    _classCallCheck(this, IApiRestDocumentacionClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP PUT /api/priv/_doc/notif
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.actualizaReglaNotifDocDoc
   */
  return _createClass(IApiRestDocumentacionClient, [{
    key: "actualizaReglaNotifDocDoc",
    value: function actualizaReglaNotifDocDoc(notifDoc, queryParams, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["api/priv/_doc/notif"]))),
        queryParams: queryParams,
        data: notifDoc,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_doc/notifs
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.reglasNotificacionDoc
     */
  }, {
    key: "reglasNotificacionDoc",
    value: function reglasNotificacionDoc(queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["api/priv/_doc/notifs"]))),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_doc/valida
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.actualizaReglaValidacionDocObligatoria
     */
  }, {
    key: "actualizaReglaValidacionDocObligatoria",
    value: function actualizaReglaValidacionDocObligatoria(notifDoc, queryParams, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["api/priv/_doc/valida"]))),
        queryParams: queryParams,
        data: notifDoc,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_doc/valida
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.reglasValidacionDocObligatoria
     */
  }, {
    key: "reglasValidacionDocObligatoria",
    value: function reglasValidacionDocObligatoria(queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["api/priv/_doc/valida"]))),
        queryParams: queryParams,
        options: options
      });
    }
  }]);
}();
export var IApiRestEdicionFormulariosClient = /*#__PURE__*/function () {
  function IApiRestEdicionFormulariosClient(httpClient) {
    _classCallCheck(this, IApiRestEdicionFormulariosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP POST /api/priv/_f/add
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.nuevoFormulario
   */
  return _createClass(IApiRestEdicionFormulariosClient, [{
    key: "nuevoFormulario",
    value: function nuevoFormulario(alta, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["api/priv/_f/add"]))),
        data: alta,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_f/ed/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.leerFormulario
     */
  }, {
    key: "leerFormulario",
    value: function leerFormulario(idform, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["api/priv/_f/ed/", ""])), idform),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_f/ed/{idform}/b
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.nuevoBloque
     */
  }, {
    key: "nuevoBloque",
    value: function nuevoBloque(idform, bloque, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["api/priv/_f/ed/", "/b"])), idform),
        data: bloque,
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_f/ed/{idform}/b/{idbloque}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.actualizaBloque
     */
  }, {
    key: "actualizaBloque",
    value: function actualizaBloque(idform, idbloque, bloque, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["api/priv/_f/ed/", "/b/", ""])), idform, idbloque),
        data: bloque,
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_f/f/{idform}/dup
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.duplicaFormulario
     */
  }, {
    key: "duplicaFormulario",
    value: function duplicaFormulario(idform, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["api/priv/_f/f/", "/dup"])), idform),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_f/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.listaFormularios
     */
  }, {
    key: "listaFormularios",
    value: function listaFormularios(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["api/priv/_f/list"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_f/listp
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.listaPreguntas
     */
  }, {
    key: "listaPreguntas",
    value: function listaPreguntas(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["api/priv/_f/listp"]))),
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_f/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.actualizaForm
     */
  }, {
    key: "actualizaForm",
    value: function actualizaForm(alta, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["api/priv/_f/save"]))),
        data: alta,
        options: options
      });
    }
  }]);
}();
export var IApiRestEdicionPreguntasClient = /*#__PURE__*/function () {
  function IApiRestEdicionPreguntasClient(httpClient) {
    _classCallCheck(this, IApiRestEdicionPreguntasClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP POST /api/priv/_q/add
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.nuevoPregunta
   */
  return _createClass(IApiRestEdicionPreguntasClient, [{
    key: "nuevoPregunta",
    value: function nuevoPregunta(alta, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["api/priv/_q/add"]))),
        data: alta,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_q/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.listaPreguntas
     */
  }, {
    key: "listaPreguntas",
    value: function listaPreguntas(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["api/priv/_q/list"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_q/pr_uses/{idpreg}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.usosPregunta
     */
  }, {
    key: "usosPregunta",
    value: function usosPregunta(idpreg, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["api/priv/_q/pr_uses/", ""])), idpreg),
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_q/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.actualizaPregunta
     */
  }, {
    key: "actualizaPregunta",
    value: function actualizaPregunta(alta, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["api/priv/_q/save"]))),
        data: alta,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_q/v/{idpreg}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.leerPregunta
     */
  }, {
    key: "leerPregunta",
    value: function leerPregunta(idpreg, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["api/priv/_q/v/", ""])), idpreg),
        options: options
      });
    }
  }]);
}();
export var IApiRestFormulariosClient = /*#__PURE__*/function () {
  function IApiRestFormulariosClient(httpClient) {
    _classCallCheck(this, IApiRestFormulariosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/priv/_f/_vm/{idmenu}
   * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormularios.leerFormularioDeMenu
   */
  return _createClass(IApiRestFormulariosClient, [{
    key: "leerFormularioDeMenu",
    value: function leerFormularioDeMenu(idmenu, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["api/priv/_f/_vm/", ""])), idmenu),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_f/{idmenu}/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormularios.leerFormulario
     */
  }, {
    key: "leerFormulario",
    value: function leerFormulario(idmenu, idform, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["api/priv/_f/", "/", ""])), idmenu, idform),
        options: options
      });
    }
  }]);
}();
export var IApiRestFormulariosPublicosClient = /*#__PURE__*/function () {
  function IApiRestFormulariosPublicosClient(httpClient) {
    _classCallCheck(this, IApiRestFormulariosPublicosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/publ/_f/_vm/{idmenu}
   * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormulariosPublicos.leerFormularioPublicoDeMenu
   */
  return _createClass(IApiRestFormulariosPublicosClient, [{
    key: "leerFormularioPublicoDeMenu",
    value: function leerFormularioPublicoDeMenu(idmenu, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["api/publ/_f/_vm/", ""])), idmenu),
        options: options
      });
    }

    /**
     * HTTP GET /api/publ/_f/{idmenu}/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormulariosPublicos.leerFormularioPublico
     */
  }, {
    key: "leerFormularioPublico",
    value: function leerFormularioPublico(idmenu, idform, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["api/publ/_f/", "/", ""])), idmenu, idform),
        options: options
      });
    }
  }]);
}();
export var IApiRestGestionCurriculumsClient = /*#__PURE__*/function () {
  function IApiRestGestionCurriculumsClient(httpClient) {
    _classCallCheck(this, IApiRestGestionCurriculumsClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP POST /api/priv/_cv/cv/{idcv}/act
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.nuevaAccionParaCV
   */
  return _createClass(IApiRestGestionCurriculumsClient, [{
    key: "nuevaAccionParaCV",
    value: function nuevaAccionParaCV(idcv, accion, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["api/priv/_cv/cv/", "/act"])), idcv),
        data: accion,
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_cv/cv/{idcv}/idoc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.nuevoDocInternoParaCV
     */
  }, {
    key: "nuevoDocInternoParaCV",
    value: function nuevoDocInternoParaCV(idcv, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["api/priv/_cv/cv/", "/idoc"])), idcv),
        options: options
      });
    }

    /**
     * HTTP DELETE /api/priv/_cv/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.borrarDocInterno
     */
  }, {
    key: "borrarDocInterno",
    value: function borrarDocInterno(idcv, iddoc, queryParams, options) {
      return this.httpClient.request({
        method: "DELETE",
        url: uriEncoding(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["api/priv/_cv/cv/", "/idoc/", ""])), idcv, iddoc),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.descargaDOCInterno
     */
  }, {
    key: "descargaDOCInterno",
    value: function descargaDOCInterno(idcv, iddoc, queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["api/priv/_cv/cv/", "/idoc/", ""])), idcv, iddoc),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.leerCv
     */
  }, {
    key: "leerCv",
    value: function leerCv(idform, idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["api/priv/_cv/cv/", "/", ""])), idform, idcv),
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_cv/cv/{idform}/{idcv}/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.editarFormCV
     */
  }, {
    key: "editarFormCV",
    value: function editarFormCV(idform, idcv, edicion, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["api/priv/_cv/cv/", "/", "/ed"])), idform, idcv),
        data: edicion,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/cv/{idform}/{idcv}/f
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.leerFormCv
     */
  }, {
    key: "leerFormCv",
    value: function leerFormCv(idform, idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["api/priv/_cv/cv/", "/", "/f"])), idform, idcv),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/cvid/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.registroCv
     */
  }, {
    key: "registroCv",
    value: function registroCv(idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["api/priv/_cv/cvid/", ""])), idcv),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/doc/{tkn}/{uuidoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.descargaDOC
     */
  }, {
    key: "descargaDOC",
    value: function descargaDOC(tkn, uuidoc, queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["api/priv/_cv/doc/", "/", ""])), tkn, uuidoc),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/f/f/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.pregsSeleccionCurriculumsFormulario
     */
  }, {
    key: "pregsSeleccionCurriculumsFormulario",
    value: function pregsSeleccionCurriculumsFormulario(idform, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["api/priv/_cv/f/f/", ""])), idform),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/f/{idformular}/{idformq}/{idq}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.valoresParaSeleccion
     */
  }, {
    key: "valoresParaSeleccion",
    value: function valoresParaSeleccion(idformular, idformq, idq, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["api/priv/_cv/f/", "/", "/", ""])), idformular, idformq, idq),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/f/{idmen}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.pregsSeleccionCurriculums
     */
  }, {
    key: "pregsSeleccionCurriculums",
    value: function pregsSeleccionCurriculums(idmen, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["api/priv/_cv/f/", ""])), idmen),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_cv/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.findCV
     */
  }, {
    key: "findCV",
    value: function findCV(filtros, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["api/priv/_cv/find"]))),
        data: filtros,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/forms
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.opcionesSeleccionCurriculums
     */
  }, {
    key: "opcionesSeleccionCurriculums",
    value: function opcionesSeleccionCurriculums(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["api/priv/_cv/forms"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/last
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.lastCV
     */
  }, {
    key: "lastCV",
    value: function lastCV(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["api/priv/_cv/last"]))),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_cv/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.listCV
     */
  }, {
    key: "listCV",
    value: function listCV(filtros, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["api/priv/_cv/list"]))),
        data: filtros,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/regs
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.regsCV
     */
  }, {
    key: "regsCV",
    value: function regsCV(queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["api/priv/_cv/regs"]))),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cv/total
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.totalCV
     */
  }, {
    key: "totalCV",
    value: function totalCV(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["api/priv/_cv/total"]))),
        options: options
      });
    }
  }]);
}();
export var IApiRestGestionFormsInternosClient = /*#__PURE__*/function () {
  function IApiRestGestionFormsInternosClient(httpClient) {
    _classCallCheck(this, IApiRestGestionFormsInternosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP POST /api/priv/_fi/cv/{idcv}/act
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.nuevaAccionParaCV
   */
  return _createClass(IApiRestGestionFormsInternosClient, [{
    key: "nuevaAccionParaCV",
    value: function nuevaAccionParaCV(idcv, accion, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["api/priv/_fi/cv/", "/act"])), idcv),
        data: accion,
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_fi/cv/{idcv}/idoc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.nuevoDocInternoParaCV
     */
  }, {
    key: "nuevoDocInternoParaCV",
    value: function nuevoDocInternoParaCV(idcv, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["api/priv/_fi/cv/", "/idoc"])), idcv),
        options: options
      });
    }

    /**
     * HTTP DELETE /api/priv/_fi/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.borrarDocInterno
     */
  }, {
    key: "borrarDocInterno",
    value: function borrarDocInterno(idcv, iddoc, queryParams, options) {
      return this.httpClient.request({
        method: "DELETE",
        url: uriEncoding(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["api/priv/_fi/cv/", "/idoc/", ""])), idcv, iddoc),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.descargaDOCInterno
     */
  }, {
    key: "descargaDOCInterno",
    value: function descargaDOCInterno(idcv, iddoc, queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["api/priv/_fi/cv/", "/idoc/", ""])), idcv, iddoc),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.leerCv
     */
  }, {
    key: "leerCv",
    value: function leerCv(idform, idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["api/priv/_fi/cv/", "/", ""])), idform, idcv),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/cvid/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.registroCv
     */
  }, {
    key: "registroCv",
    value: function registroCv(idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["api/priv/_fi/cvid/", ""])), idcv),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/doc/{tkn}/{uuidoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.descargaDOC
     */
  }, {
    key: "descargaDOC",
    value: function descargaDOC(tkn, uuidoc, queryParams, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["api/priv/_fi/doc/", "/", ""])), tkn, uuidoc),
        queryParams: queryParams,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/f/f/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.pregsSeleccionCurriculumsFormulario
     */
  }, {
    key: "pregsSeleccionCurriculumsFormulario",
    value: function pregsSeleccionCurriculumsFormulario(idform, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["api/priv/_fi/f/f/", ""])), idform),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/f/{idformular}/{idformq}/{idq}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.valoresParaSeleccion
     */
  }, {
    key: "valoresParaSeleccion",
    value: function valoresParaSeleccion(idformular, idformq, idq, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["api/priv/_fi/f/", "/", "/", ""])), idformular, idformq, idq),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/f/{idmen}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.pregsSeleccionCurriculums
     */
  }, {
    key: "pregsSeleccionCurriculums",
    value: function pregsSeleccionCurriculums(idmen, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["api/priv/_fi/f/", ""])), idmen),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_fi/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.findCV
     */
  }, {
    key: "findCV",
    value: function findCV(filtros, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["api/priv/_fi/find"]))),
        data: filtros,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/forms
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.opcionesSeleccionCurriculums
     */
  }, {
    key: "opcionesSeleccionCurriculums",
    value: function opcionesSeleccionCurriculums(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["api/priv/_fi/forms"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/last
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.lastCV
     */
  }, {
    key: "lastCV",
    value: function lastCV(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["api/priv/_fi/last"]))),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_fi/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.listCV
     */
  }, {
    key: "listCV",
    value: function listCV(filtros, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["api/priv/_fi/list"]))),
        data: filtros,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_fi/total
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.totalCV
     */
  }, {
    key: "totalCV",
    value: function totalCV(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["api/priv/_fi/total"]))),
        options: options
      });
    }
  }]);
}();
export var IApiRestGestionMenuClient = /*#__PURE__*/function () {
  function IApiRestGestionMenuClient(httpClient) {
    _classCallCheck(this, IApiRestGestionMenuClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP POST /api/priv/_m/add
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.nuevoMenu
   */
  return _createClass(IApiRestGestionMenuClient, [{
    key: "nuevoMenu",
    value: function nuevoMenu(alta, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["api/priv/_m/add"]))),
        data: alta,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_m/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.menusNavegacion
     */
  }, {
    key: "menusNavegacion",
    value: function menusNavegacion(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["api/priv/_m/ed"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_m/form
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.formulariosSeleccion
     */
  }, {
    key: "formulariosSeleccion",
    value: function formulariosSeleccion(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["api/priv/_m/form"]))),
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_m/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.actualizaMenu
     */
  }, {
    key: "actualizaMenu",
    value: function actualizaMenu(alta, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["api/priv/_m/save"]))),
        data: alta,
        options: options
      });
    }
  }]);
}();
export var IApiRestGestionTextosClient = /*#__PURE__*/function () {
  function IApiRestGestionTextosClient(httpClient) {
    _classCallCheck(this, IApiRestGestionTextosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP POST /api/priv/_t/add
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.nuevoTexto
   */
  return _createClass(IApiRestGestionTextosClient, [{
    key: "nuevoTexto",
    value: function nuevoTexto(alta, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["api/priv/_t/add"]))),
        data: alta,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_t/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.textos
     */
  }, {
    key: "textos",
    value: function textos(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["api/priv/_t/ed"]))),
        options: options
      });
    }

    /**
     * HTTP PUT /api/priv/_t/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.actualizaTextos
     */
  }, {
    key: "actualizaTextos",
    value: function actualizaTextos(alta, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["api/priv/_t/save"]))),
        data: alta,
        options: options
      });
    }
  }]);
}();
export var IApiRestHistoricoCurriculumsClient = /*#__PURE__*/function () {
  function IApiRestHistoricoCurriculumsClient(httpClient) {
    _classCallCheck(this, IApiRestHistoricoCurriculumsClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/priv/_cvhist/cv/{idcv}
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.datosCvHistorico
   */
  return _createClass(IApiRestHistoricoCurriculumsClient, [{
    key: "datosCvHistorico",
    value: function datosCvHistorico(idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["api/priv/_cvhist/cv/", ""])), idcv),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cvhist/cv/{idcv}/rel
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.buscarHistoricosRelacionados
     */
  }, {
    key: "buscarHistoricosRelacionados",
    value: function buscarHistoricosRelacionados(idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["api/priv/_cvhist/cv/", "/rel"])), idcv),
        options: options
      });
    }

    /**
     * HTTP DELETE /api/priv/_cvhist/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.borrarCv
     */
  }, {
    key: "borrarCv",
    value: function borrarCv(idform, idcv, options) {
      return this.httpClient.request({
        method: "DELETE",
        url: uriEncoding(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["api/priv/_cvhist/cv/", "/", ""])), idform, idcv),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_cvhist/cv_rel_hist
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.buscarCoincidenciasHistorico
     */
  }, {
    key: "buscarCoincidenciasHistorico",
    value: function buscarCoincidenciasHistorico(peticion, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["api/priv/_cvhist/cv_rel_hist"]))),
        data: peticion,
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_cvhist/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.listCV
     */
  }, {
    key: "listCV",
    value: function listCV(filtros, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["api/priv/_cvhist/find"]))),
        data: filtros,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cvhist/regs_pend
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.regsCVPendientesHist
     */
  }, {
    key: "regsCVPendientesHist",
    value: function regsCVPendientesHist(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["api/priv/_cvhist/regs_pend"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_cvhist/resp_hist
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.respuestasHistorico
     */
  }, {
    key: "respuestasHistorico",
    value: function respuestasHistorico(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["api/priv/_cvhist/resp_hist"]))),
        options: options
      });
    }
  }]);
}();
export var IApiRestHistoricoFormsInternosClient = /*#__PURE__*/function () {
  function IApiRestHistoricoFormsInternosClient(httpClient) {
    _classCallCheck(this, IApiRestHistoricoFormsInternosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/priv/_fihist/cv/{idcv}
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.datosCvHistorico
   */
  return _createClass(IApiRestHistoricoFormsInternosClient, [{
    key: "datosCvHistorico",
    value: function datosCvHistorico(idcv, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["api/priv/_fihist/cv/", ""])), idcv),
        options: options
      });
    }

    /**
     * HTTP DELETE /api/priv/_fihist/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.borrarCv
     */
  }, {
    key: "borrarCv",
    value: function borrarCv(idform, idcv, options) {
      return this.httpClient.request({
        method: "DELETE",
        url: uriEncoding(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["api/priv/_fihist/cv/", "/", ""])), idform, idcv),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_fihist/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.listCV
     */
  }, {
    key: "listCV",
    value: function listCV(filtros, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["api/priv/_fihist/find"]))),
        data: filtros,
        options: options
      });
    }
  }]);
}();
export var IApiRestLoginClient = /*#__PURE__*/function () {
  function IApiRestLoginClient(httpClient) {
    _classCallCheck(this, IApiRestLoginClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/priv/_w/_auth
   * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.authDetails
   */
  return _createClass(IApiRestLoginClient, [{
    key: "authDetails",
    value: function authDetails(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["api/priv/_w/_auth"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_w/_logout
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.logout
     */
  }, {
    key: "logout",
    value: function logout(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["api/priv/_w/_logout"]))),
        options: options
      });
    }

    /**
     * HTTP POST /api/priv/_w/login
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.login
     */
  }, {
    key: "login",
    value: function (_login) {
      function login(_x, _x2) {
        return _login.apply(this, arguments);
      }
      login.toString = function () {
        return _login.toString();
      };
      return login;
    }(function (login, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["api/priv/_w/login"]))),
        data: login,
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_w/whoami
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.userDetails
     */)
  }, {
    key: "userDetails",
    value: function userDetails(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["api/priv/_w/whoami"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_w/whoamicfg
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.userDetailsConConfig
     */
  }, {
    key: "userDetailsConConfig",
    value: function userDetailsConConfig(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["api/priv/_w/whoamicfg"]))),
        options: options
      });
    }
  }]);
}();
export var IApiRestMainQuestionsClient = /*#__PURE__*/function () {
  function IApiRestMainQuestionsClient(httpClient) {
    _classCallCheck(this, IApiRestMainQuestionsClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP PUT /api/_mq/ed/e/{idmq}/mod_mq
   * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.editarPregPrincipal
   */
  return _createClass(IApiRestMainQuestionsClient, [{
    key: "editarPregPrincipal",
    value: function editarPregPrincipal(idmq, data, options) {
      return this.httpClient.request({
        method: "PUT",
        url: uriEncoding(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["api/_mq/ed/e/", "/mod_mq"])), idmq),
        data: data,
        options: options
      });
    }

    /**
     * HTTP POST /api/_mq/ed/n/n_mq
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.altaPregPrincipal
     */
  }, {
    key: "altaPregPrincipal",
    value: function altaPregPrincipal(data, options) {
      return this.httpClient.request({
        method: "POST",
        url: uriEncoding(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["api/_mq/ed/n/n_mq"]))),
        data: data,
        options: options
      });
    }

    /**
     * HTTP GET /api/_mq/get/{idmq}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.leerPregPrincipal
     */
  }, {
    key: "leerPregPrincipal",
    value: function leerPregPrincipal(idmq, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["api/_mq/get/", ""])), idmq),
        options: options
      });
    }

    /**
     * HTTP GET /api/_mq/l
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.todasLasPregPrincipales
     */
  }, {
    key: "todasLasPregPrincipales",
    value: function todasLasPregPrincipales(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["api/_mq/l"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/_mq/ll
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.todasLasPregPrincipalesConPreg
     */
  }, {
    key: "todasLasPregPrincipalesConPreg",
    value: function todasLasPregPrincipalesConPreg(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["api/_mq/ll"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/_mq/mq_uses/{idmq}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.usosPregPrincipal
     */
  }, {
    key: "usosPregPrincipal",
    value: function usosPregPrincipal(idmq, options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["api/_mq/mq_uses/", ""])), idmq),
        options: options
      });
    }
  }]);
}();
export var IApiRestMenuClient = /*#__PURE__*/function () {
  function IApiRestMenuClient(httpClient) {
    _classCallCheck(this, IApiRestMenuClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/priv/_m/start
   * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicio
   */
  return _createClass(IApiRestMenuClient, [{
    key: "menuInicio",
    value: function menuInicio(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["api/priv/_m/start"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_m/startcfg
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicioConfig
     */
  }, {
    key: "menuInicioConfig",
    value: function menuInicioConfig(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["api/priv/_m/startcfg"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/priv/_m/startcfg/priv
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicioConfigMenusPrivados
     */
  }, {
    key: "menuInicioConfigMenusPrivados",
    value: function menuInicioConfigMenusPrivados(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["api/priv/_m/startcfg/priv"]))),
        options: options
      });
    }
  }]);
}();
export var IApiRestMenuPublicosClient = /*#__PURE__*/function () {
  function IApiRestMenuPublicosClient(httpClient) {
    _classCallCheck(this, IApiRestMenuPublicosClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/publ/_m/startcfg/publ
   * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenuPublicos.menuInicioConfigMenusPublicos
   */
  return _createClass(IApiRestMenuPublicosClient, [{
    key: "menuInicioConfigMenusPublicos",
    value: function menuInicioConfigMenusPublicos(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["api/publ/_m/startcfg/publ"]))),
        options: options
      });
    }
  }]);
}();
export var IApiRestViewClient = /*#__PURE__*/function () {
  function IApiRestViewClient(httpClient) {
    _classCallCheck(this, IApiRestViewClient);
    this.httpClient = httpClient;
  }

  /**
   * HTTP GET /api/view/auth
   * Java method: com.caxtoncollege.candidato.webapp.view.ApiRestView.userDetails
   */
  return _createClass(IApiRestViewClient, [{
    key: "userDetails",
    value: function userDetails(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["api/view/auth"]))),
        options: options
      });
    }

    /**
     * HTTP GET /api/view/cv
     * Java method: com.caxtoncollege.candidato.webapp.view.ApiRestView.userDetails2
     */
  }, {
    key: "userDetails2",
    value: function userDetails2(options) {
      return this.httpClient.request({
        method: "GET",
        url: uriEncoding(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["api/view/cv"]))),
        options: options
      });
    }
  }]);
}();
function uriEncoding(template) {
  var result = "";
  for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
    result += template[i];
    result += encodeURIComponent(i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]);
  }
  result += template[template.length - 1];
  return result;
}